import { gql } from "@apollo/client";

export const GET_ALL_MEDIO_ENVIO = gql`
query GetAllMedioEnvioPresupuesto {
    allMedioEnvioPresupuesto {
        idMedioEnvioPresupuesto
        descripcion
    }
}
`;

export const adaptMedioEnvio = (medioEnvio) => {
  return {
    id: medioEnvio?.idMedioEnvioPresupuesto,
    displayName: medioEnvio?.descripcion
  };
};

export const adaptMedioEnvioArray = (
allMedioEnvioPresupuesto) =>
{
  return structuredClone(allMedioEnvioPresupuesto)?.
  map((medioEnvio) => adaptMedioEnvio(medioEnvio));
};